import { data } from '../../svg/ChipExtraction/data';
import { makeIcon } from '../makeIcon';

export const ChipExtraction = makeIcon(data, 'chip_extraction', 'ChipExtraction');

export default ChipExtraction;
